import { useItemSet } from '@exam-management/common/item-set-provider';
import { type ConfirmationModalProps } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';

import { PendingQuestionModal } from '../../components';

type PendingItemSetQuestionModalProps = Pick<ConfirmationModalProps, 'onClose' | 'open'>;

export default function PendingItemSetQuestionModal(
  props: Readonly<PendingItemSetQuestionModalProps>,
) {
  const { open: isOpen, onClose } = props;

  const { pending, isUpdatingToPending } = useItemSet();
  const { showSnackbar } = useSnackbar();

  const handleAccept: React.MouseEventHandler<HTMLButtonElement> = async (event) => {
    await pending({
      onCompleted: () => {
        showSnackbar({
          message: 'Question has been pending',
          variant: 'success',
        });
        onClose?.(event);
      },
      onError: () => {
        showSnackbar({
          message: 'Unable to Pending Question',
          variant: 'error',
        });
        onClose?.(event);
      },
    });
  };

  const handleClose: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    onClose?.(event);
  };

  return (
    <PendingQuestionModal
      open={isOpen}
      loading={isUpdatingToPending}
      onAccept={handleAccept}
      onClose={handleClose}
    />
  );
}
